import { render, staticRenderFns } from "./agTable.vue?vue&type=template&id=aafb7902&scoped=true&"
import script from "./agTable.vue?vue&type=script&lang=js&"
export * from "./agTable.vue?vue&type=script&lang=js&"
import style0 from "./agTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./agTable.vue?vue&type=style&index=1&id=aafb7902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafb7902",
  null
  
)

export default component.exports